import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  itemsList: {
    padding: theme.spacing(),
    height: '100%',
    width: '100%',
    '& .testing': {
      right: [0, '!important']
    }
  },
  item: {
    cursor: 'pointer',
    margin: '20px 0',
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`
  },
  itemImage: {
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    paddingTop: '46.37%',
    position: 'relative'
  },
  bottomContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    padding: theme.spacing(2, 1.5)
  },
  itemType: {
    position: 'absolute',
    left: 0,
    bottom: 0
  },
  itemName: {
    flexGrow: 1,
    flexShrink: 1,
    display: 'flex',
    alignItems: 'center'
  },
  itemNameTypography: {
    color: '#001F54',
    fontFamily: 'Poppins, Roboto, sans-serif',
    fontSize: 16,
    fontWeight: 700,
    flexGrow: 1
  },
  itemCost: {
    flexGrow: 0,
    flexShrink: 0
  },
  itemCostTypography: {
    color: theme.palette.secondary.main,
    fontFamily: 'Oswald, Roboto, sans-serif',
    fontSize: 20,
    fontWeight: 300
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/components/ItemsList/styles.js